import React from "react";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import html from "../../../../../src/Assets/html.jpg";
import myuser from "../../../../Assets/prof.png";
import ListCourses from "../../../../Component/ListCourses/ListCourses";

import react from "../../../../Assets/html.png";

import "./AllCourses.css";
import { Nav } from "react-bootstrap";
import { AJOUT_COURS_NAVIGATION } from "../../../../Routes/NAVIGATION_PATH";
import { Link } from "react-router-dom";

export default function Cours() {
  const dataCourses = [
    {date :'20-juin-2022',description :'Révolutionnez la façon dont vous construisez le Web ...',
    titre : 'HTML',nom:'Alpha Oumar Barry',statu : 'live', isAprouved :false},
    {date :'20-juin-2021',description :'Révolutionnez la façon dont vous construisez le Web ...',
    titre : 'Javascript',nom:'Mady Shankon',statu : 'live', isAprouved :true},
    {date :'20-juin-2021',description :'Révolutionnez la façon dont vous construisez le Web ...',
    titre : 'CSS',nom:'Mady Shankon',statu : 'Pending', isAprouved :false},
    {date :'20-juin-2021',description :'Révolutionnez la façon dont vous construisez le Web ...',
    titre : 'React JS',nom:'Mady Shankon',statu : 'live', isAprouved :true},
  ]
  return (
    <div className="container-fluid " id="allCourses">
      <div className="d-flex justify-content-end ajouRecher">
          <input
            type="text"
            class="form-control"
            id="exampleInputEmail1"
            placeholder="Recherche cours"
            aria-describedby="emailHelp"
          />
          <div className="cont-btn-aj  d-flex ">
            <Link to={AJOUT_COURS_NAVIGATION}>
              <Button variant="primary">Ajouter un cours</Button>
            </Link>{" "}
          </div>
        </div>
      <Nav
        className="bg-s mx-auto  p-2"
        activeKey="/home"
        onSelect={(selectedKey) => alert(`selected ${selectedKey}`)}
      >
        <Nav.Item>
          <Nav.Link className="home" href="/home">
            All
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link className="home" eventKey="link-1">
            Approuvé
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link className="home" eventKey="link-2">
            En attente
          </Nav.Link>
        </Nav.Item>
      </Nav>
      

      <Table striped bordered hover responsive>
        <thead>
          <tr className="py-5">
            <th>Cours</th>
            <th>INSTRUCTEUR</th>
            <th>STATUT</th>
            <th>ACTION</th>
          </tr>
        </thead>
        <tbody>
        {dataCourses.map(({date,description,titre,nom,isAprouved},index)=>{
         return <ListCourses 
          date={date}
          description={description}
          titre={titre}
          nom={nom}
          isAprouved={isAprouved}
          key={index}
          />
        })}
          
          {/* <tr>
            <td className="d-flex justify-center align-items-center  p-2 ">
              <div className="container-im">
                <img className="ma p-2" src={html} />
              </div>{" "}
              <div>
                <p> Révolutionnez la façon dont vous construisez le Web ...</p>

                <span> Ajouté le 7 juillet 2020</span>
              </div>
            </td>
            <td className=" p-2 ">
              <div className="container-im">
                <img className="mab p-2" src={myuser} />{" "}
                <span>Jenny Wilson</span>
              </div>
            </td>
            <td className=" p-3 "> En attente</td>
            <td>
              {" "}
              <Button variant="success">Approuve</Button>{" "}
              <Button variant="light">Rejette</Button>
            </td>
          </tr>
          <tr>
            <td className="d-flex justify-center align-items-center  p-2 ">
              <div className="container-im">
                <img className="ma p-2" src={html} />
              </div>
              <div>
                <p> Révolutionnez la façon dont vous construisez le Web ...</p>

                <span> Ajouté le 7 juillet 2020</span>
              </div>
            </td>
            <td className=" p-2 ">
              <div className="container-im">
                <img className="mab p-2" src={myuser} />{" "}
                <span>Jenny Wilson</span>
              </div>
            </td>
            <td className=" p-3 "> En attente</td>
            <td>
              {" "}
              <Button variant="success">Approuve</Button>{" "}
              <Button variant="light">Rejette</Button>
            </td>
          </tr>
          <tr>
            <td className="d-flex justify-center align-items-center  p-2 ">
              <div className="container-im">
                <img className="ma p-2" src={react} />
              </div>
              <div>
                <p> Révolutionnez la façon dont vous construisez le Web ...</p>

                <span> Ajouté le 7 juillet 2020</span>
              </div>
            </td>
            <td className=" p-2 ">
              <div className="container-im">
                <img className="mab p-2" src={myuser} />{" "}
                <span>Jenny Wilson</span>
              </div>
            </td>
            <td className=" p-3 "> En attente</td>
            <td>
              {" "}
              <Button variant="secondary">modifier le statu</Button>
            </td>
          </tr> */}
        </tbody>
      </Table>
    </div>
  );
}
